import { Col, Field, Row, SearchInput, SearchPanel } from '@elotech/components';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

import { UrlUtils } from '../../utils';

type Props = {
  field?: Field;
  onSearch: (searchValue?: string) => void;
  textButton?: string;
  disableInitialSearch?: boolean;
  disableCharValidation?: boolean;
  saveOnUrl?: boolean;
};

const defaultField: Field = {
  label: '',
  name: '',
  type: 'STRING'
};
const BasicSearchFilter: React.FC<Props> = ({
  field = defaultField,
  onSearch,
  textButton = 'Filtrar',
  disableInitialSearch = false,
  disableCharValidation = false,
  saveOnUrl = false
}) => {
  const urlParamName = 'search';
  const history = useHistory();
  const searchValueRef = React.createRef<any>();

  const initialValue = saveOnUrl
    ? UrlUtils.getFieldOnSearchParams(history.location.search, urlParamName) ??
      ''
    : '';

  const onFilter = () => {
    const value = searchValueRef.current.getValue();
    onSearch(value);

    if (saveOnUrl) {
      const params = new URLSearchParams(history.location.search);
      if (value) {
        params.set(urlParamName, value);
      } else {
        params.delete(urlParamName);
      }
      history.replace(`${history.location.pathname}?${params.toString()}`);
    }
  };

  useEffect(() => {
    if (!disableInitialSearch) {
      onSearch(initialValue);
    }
    if (searchValueRef.current?.searchRef?.current && initialValue) {
      searchValueRef.current.searchRef.current.value = initialValue;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SearchPanel>
      <Row>
        <Col md={12}>
          <div className="form-group">
            <SearchInput
              ref={searchValueRef}
              onEnter={onFilter}
              field={field}
              autoFocus={false}
              disableCharValidation={disableCharValidation}
            />
            <button className="btn filter" type="button" onClick={onFilter}>
              {textButton}
            </button>
          </div>
        </Col>
      </Row>
    </SearchPanel>
  );
};

export default BasicSearchFilter;
